import { gql } from '@apollo/client';

export default gql`
  query booking($reference: String!) {
    booking(reference: $reference) {
      isLoyalty
      reference
      payments {
        id
        refId
        reference
        currency
        externalReference
        method
        isPayout
        isBalance
        isSuccessful
        amount: amountWithCurrency
        transactionTimestamp
        paymentStatus
        action @client
        display @client
      }
      offlineFees: fees {
        ...PaymentsFee
      }
      hotelCancellationFees {
        ...PaymentsFee
      }
      insuranceCancellationFees {
        ...PaymentsFee
      }
      hotelMarginCancellationFees {
        ...PaymentsFee
      }
      trainMarginCancellationFees {
        ...PaymentsFee
      }
      hotelExchangeFees {
        ...PaymentsFee
      }
      travelPassProductsCancellationFees(tariffCode: TH_TP_CAN_FEE) {
        ...PaymentsFee
      }
      flowForwardFees(cancelled: false) {
        ...PaymentsFee
      }
      impulseUpgradeFees(cancelled: false) {
        ...PaymentsFee
      }
      passengers {
        id
        type
        firstName
        lastName
        email
        phoneNumber
        unformattedPhoneNumber {
          countryCode
          number
        }
        birthDate
        loyaltyNumber
      }
      outbound(hideExchanged: false, sortByDepartureDate: true) {
        ...receiptLeg
      }
      inbound(hideExchanged: false, sortByDepartureDate: true) {
        ...receiptLeg
      }
      hotels {
        price
        margin
        priceWithMargin
        deprecatedTrainMargin
        passenger {
          firstName
          lastName
        }
        currency
        checkInDate
        validityEndDate
        jacTravelRef
        hotelId
        cancelled
        provisional
        itemRef
        itemId
        isDotwBooking
        eurostarReference
        bookerSurname
        canBeCancelledOnThirdParty
        hotelName
        numberOfNights
        guestCount
        roomCount
        hotelAddress
      }
      insurances {
        price
        passenger {
          firstName
          lastName
        }
        currency
        date
        policyNumber
        description
        cancelled
        provisional
        itemRef
      }
    }
  }

  fragment PaymentsFee on Fee {
    itemRef
    price: priceWithCurrency
    name
    code
    currency
    cancelled
  }

  fragment receiptLeg on Leg {
    ...receiptLegFields
    addOnLeg {
      ...receiptLegFields
    }
  }

  fragment receiptLegFields on Leg {
    isMultiInventory
    cancelled
    ticketDocuments {
      pin
    }
    serviceType {
      code
      name
      brandCode
    }
    extraProducts {
      code
      name
      price
      currency
      isCancelled
      isPendingCancellation
      passengerId
      passenger {
        firstName
        lastName
      }
    }
    direction
    trainNumber
    id
    classOfService {
      code
      name
    }
    origin {
      name
      uic
      shortCode
      timezone
      isPseudoStation
    }
    destination {
      name
      uic
      shortCode
    }
    timing {
      isoDate
      date
      departs
      arrives
    }
    fees {
      ...PaymentsFee
    }
    canBeUpgraded
    products {
      ...receiptProduct
    }
    activeBookingItems @client {
      ...receiptProduct
    }
    bookingItems @client {
      ...receiptProduct
      mealCode
      status
    }

    temporarilyCancelledBookingItems @client {
      ...receiptProduct
      mealCode
      status
    }

    meals {
      code
      passenger {
        id
      }
      price
      name
    }
    productSummaries @client {
      name
      passengerType
      code
      total
      quantity
      price
    }
    refundSummaries @client {
      name
      passengerType
      code
      total
      quantity
      price
    }
  }

  fragment receiptProduct on Product {
    itemRef
    currency
    associatedItemRefs
    passengerId
    isAFareAddOn
    isCheckedIn
    isPrrRefunded
    isRebookOFEActive
    isCancelOFEActive
    price
    ticketNumber
    tariffDetails {
      tariffCode
      bucketCode
    }
    code
    inventoryClass
    name
    cancelled
    provisional
    canBeRebooked
    canBeCancelled
    canBeRefunded
    canShowVAT
    afterSalesRules {
      active
      validUntil
      price
      override
      type
      currentActive
    }
    seat {
      carriage
      number
    }
    passenger {
      id
      type
      firstName
      lastName
      email
      phoneNumber
      unformattedPhoneNumber {
        countryCode
        number
      }
      birthDate
      loyaltyNumber
    }
    vat {
      countryCode
      rate
      amount
      price {
        includingVat
        excludingVat
        currency
      }
    }
  }
`;
